import { resumeSecondsRemaining, type PublicRoomView } from "@secret-cabinet/contracts";
import { CircleAlert, Clock3 } from "lucide-react";
import { useEffect, useState } from "react";

export function PhaseBanner({ room, compact = false }: { room: PublicRoomView; compact?: boolean }) {
  const [clock, setClock] = useState(() => Date.now());
  const resumeAt = room.pause.resumeAt;

  useEffect(() => {
    if (resumeAt === null) {
      return;
    }
    setClock(Date.now());
    const interval = window.setInterval(() => setClock(Date.now()), 100);
    return () => window.clearInterval(interval);
  }, [resumeAt]);

  const resumeSeconds = resumeAt === null ? null : resumeSecondsRemaining(resumeAt, clock);
  const instruction = resumeSeconds === null
    ? room.phaseInstruction
    : `Resuming in ${resumeSeconds} second${resumeSeconds === 1 ? "" : "s"}.`;

  return (
    <section
      className={`phase-banner${compact ? " phase-banner--compact" : ""}${
        room.pause.active ? " phase-banner--paused" : ""
      }`}
      aria-live="polite"
    >
      <span className="phase-banner__index">
        {room.pause.active ? <CircleAlert aria-hidden="true" /> : <Clock3 aria-hidden="true" />}
        {room.pause.active ? "Session paused" : phaseIndex(room.phase)}
      </span>
      {!compact ? <h1>{room.phaseLabel}</h1> : <h2>{room.phaseLabel}</h2>}
      <p>{instruction}</p>
    </section>
  );
}

function phaseIndex(phase: PublicRoomView["phase"]): string {
  switch (phase) {
    case "lobby":
      return "Before the first sitting";
    case "role-reveal":
      return "Private briefing";
    case "nomination":
    case "election":
    case "election-result":
      return "Election business";
    case "legislative-president":
    case "legislative-chancellor":
    case "veto-president":
    case "policy-result":
      return "Legislative business";
    case "executive-investigate":
    case "executive-investigation-result":
    case "executive-policy-peek":
    case "executive-special-election":
    case "executive-execution":
      return "Presidential power";
    case "game-over":
      return "Final record";
  }
}
